import { useTheme } from '@mui/material';

import { Accordion } from 'sharedComponents/Accordion/Accordion';
import { AccordionCTAExpanded } from './AccordionCTAExpanded';
import {
  AccordionTitleContainer,
  ActionsTitle,
  detailsSx,
  summarySx,
} from '../../../styles/actionsStyles';
import { ActionsAccordionProps } from '../../../types';
import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import { ExpandIcon } from './Icons';
import { getRequiredActionsTitleText } from '../../../utils';

export const ActionsAccordion: React.FC<ActionsAccordionProps> = ({
  actions,
  applicationLink,
  candidateId,
  handleExpansion,
  isExpanded,
  onOpenModal,
  requirements,
  roleId,
  hasCompletedAllActions,
  requiredActions,
  hasCompletedAllRequiredActions,
}) => {
  const theme = useTheme();

  const getBackgroundColor = () => {
    if (hasCompletedAllRequiredActions) {
      return theme.palette.primary.fill;
    }

    return theme.palette.gray.lightest;
  };

  return (
    <Accordion
      dataTestId={ATSConnectHiringRequestTestIds.ACTIONS_ACCORDION}
      detailsSx={{
        ...detailsSx,
        backgroundColor: getBackgroundColor(),
      }}
      disableGutters
      expandIcon={<ExpandIcon />}
      onChange={handleExpansion}
      summarySx={{
        ...summarySx,
        backgroundColor: getBackgroundColor(),
      }}
      title={
        <AccordionTitleContainer data-testid={ATSConnectHiringRequestTestIds.ACCORDION_TITLE}>
          <ActionsTitle>
            {getRequiredActionsTitleText(
              hasCompletedAllActions,
              requirements,
              requiredActions,
              actions
            )}
          </ActionsTitle>
        </AccordionTitleContainer>
      }
    >
      <AccordionCTAExpanded
        actions={actions}
        candidateId={candidateId}
        isExpanded={isExpanded}
        onOpenModal={onOpenModal}
        requirements={requirements}
        roleId={roleId}
        applicationLink={applicationLink}
      />
    </Accordion>
  );
};
